// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spinner {
  to {transform: rotate(360deg);}
}

.spinner-container { 
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: auto;
  grid-template-rows: auto;
  align-items: center;
  justify-items: center;
}

.spinner-wrapper {
    display: inline-block;
    text-align: center;
    margin: auto auto;
}

.spinner-wrapper .spinner:before {
  content: '';
  display: inline-block;
  box-sizing: border-box;
  margin: auto auto;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: 2px solid var(--primary-color-light);
  border-top-color: var(--primary-color-darkest);;
  animation: spinner .6s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./client/components/Spinner.css"],"names":[],"mappings":"AAAA;EACE,IAAI,yBAAyB,CAAC;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4CAA4C;EAC5C,8CAA8C;EAC9C,sCAAsC;AACxC","sourcesContent":["@keyframes spinner {\n  to {transform: rotate(360deg);}\n}\n\n.spinner-container { \n  display: grid;\n  width: 100%;\n  height: 100%;\n  grid-template-columns: auto;\n  grid-template-rows: auto;\n  align-items: center;\n  justify-items: center;\n}\n\n.spinner-wrapper {\n    display: inline-block;\n    text-align: center;\n    margin: auto auto;\n}\n\n.spinner-wrapper .spinner:before {\n  content: '';\n  display: inline-block;\n  box-sizing: border-box;\n  margin: auto auto;\n  width: 1em;\n  height: 1em;\n  border-radius: 50%;\n  border: 2px solid var(--primary-color-light);\n  border-top-color: var(--primary-color-darkest);;\n  animation: spinner .6s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
